import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InterchangeScreenData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InterchangeScreenDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InterchangeScreenDataStore",
			variables: false,
		})
	}
}

export async function load_InterchangeScreenData(params) {
  await initClient()

	const store = new InterchangeScreenDataStore()

	await store.fetch(params)

	return {
		InterchangeScreenData: store,
	}
}
